'use client'

import { MdClose } from 'react-icons/md'

import { Modal } from '@dd3tech/wiggui/Modal'
import { Text } from '@dd3tech/wiggui/Text'
import { Button } from '@dd3tech/wiggui/Button'
import { composeClasses } from '../../../utils/src/strings'

import PlanAdvanceImg from './svg/plan-advance'
import PlanStarterImg from './svg/plan-starter'

export enum ModalType {
  STARTER = 'starter',
  ADVANCE = 'advance',
  WITHOUT_REPORTS = 'without_reports'
}

interface UpgradeModalProps {
  showModal: boolean
  handleShowModal: () => void
  type?: Lowercase<keyof typeof ModalType>
}

const modalTypes: {
  [key in ModalType]: {
    title: string
    description: string
    buttonCancelText: string
    buttonNextTex?: string
    linkTex?: string
    img: any
  }
} = {
  starter: {
    title: 'Adquiere un plan para continuar',
    description:
      'No cuentas con un plan activo. Para continuar, adquiere uno en nuestra tienda.',
    buttonCancelText: 'Salir',
    buttonNextTex: 'Ir a la tienda',
    img: <PlanStarterImg />
  },
  advance: {
    title: 'Cámbiate a Advanced',
    description:
      'Aprovecha al máximo los beneficios de ser Advanced como: vinculaciones ilimitadas, descargar PDF, compartir listas y mucho más.',
    linkTex: 'Compara los planes',
    buttonCancelText: 'Cancelar',
    buttonNextTex: 'Mejorar a Advanced',
    img: <PlanAdvanceImg />
  },
  without_reports: {
    title: 'Ya no tienes reportes disponibles',
    description: 'Has alcanzado tu límite de reportes.',
    buttonCancelText: 'Cerrar',
    img: <PlanStarterImg />
  }
}

export const UpgradePlanModal = ({
  showModal,
  handleShowModal,
  type = ModalType.STARTER
}: UpgradeModalProps) => {
  const gotoExternalPath = () => {
    window.location.href = `${window.location.origin}/shop`
  }

  const classTextColor =
    type === ModalType.WITHOUT_REPORTS ? 'text-primary' : 'text-white'

  return (
    <Modal
      isOpen={showModal}
      className={composeClasses(
        'w-full md:w-[524px] fixed md:static bottom-0',
        type === ModalType.WITHOUT_REPORTS
          ? 'bg-surface-white'
          : '!bg-surface-bg-black'
      )}
      onClose={handleShowModal}
      isResponsive={false}
      enableBgBlur
    >
      <Modal.Header className="relative flex justify-between items-center w-full h-12 p-7 border-b">
        <p className={composeClasses('text-body-xl  w-full', classTextColor)}>
          {modalTypes[type].title}
        </p>
        <button
          type="button"
          className={composeClasses(
            'absolute right-0 flex justify-center items-center w-12 h-12 p-3 mr-3',
            classTextColor
          )}
          onClick={handleShowModal}
        >
          <MdClose className="w-6 h-6" />
        </button>
      </Modal.Header>

      <Modal.Body className="flex flex-col gap-6 w-full justify-center items-center">
        {modalTypes[type].img}
        {/* <img
          src={modalTypes[type].img}
          alt="Decorative illustration"
          className="h-48"
        /> */}

        <div className="flex flex-col items-center text-center">
          <Text
            className={composeClasses(
              'text-body-m font-normal text-center',
              classTextColor
            )}
          >
            {modalTypes[type].description}
          </Text>

          {type === ModalType.ADVANCE && (
            <Button
              className={classTextColor}
              variant="link"
              onClick={gotoExternalPath}
            >
              Compara los planes
            </Button>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer className="flex justify-center gap-3 w-full px-6 py-2 border-t border-strokes">
        <Button
          className="w-full"
          variant="secondary"
          onClick={handleShowModal}
        >
          {modalTypes[type].buttonCancelText}
        </Button>

        {type !== ModalType.WITHOUT_REPORTS && (
          <Button
            className="w-full"
            variant="primary"
            onClick={gotoExternalPath}
          >
            {modalTypes[type].buttonNextTex}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  )
}
